export default function triggerEvent(el, type) {
  if ('createEvent' in document) {
    // modern browsers, IE9+
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  }
}
//# sourceMappingURL=triggerEvent.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/triggerEvent.js
// module id = 751
// module chunks = 3